import React from "react";

function Footer() {
  return (
    <>
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright &copy; Klout Membership 2024-25</span>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
